"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.submissionIdNamespace = exports.Dumbapp = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _uuid = require("uuid");
var _remeda = require("remeda");
var _util = require("./util");
const submissionIdNamespace = exports.submissionIdNamespace = "6415cdde-2700-46e5-b2ae-b133d2a4b9a6";
class Dumbapp {
  static uuidData(shortcode, created, from) {
    return shortcode + "@" + created + "@" + from;
  }
  static uuid(shortcode, created, from) {
    // from is like that just in case an undefined or null gets passed
    return (0, _uuid.v5)(this.uuidData(shortcode, created, from), submissionIdNamespace).toString();
  }
  static uuidFromData(uuidData) {
    return (0, _uuid.v5)(uuidData, submissionIdNamespace).toString();
  }
  constructor(data) {
    var _this$steps;
    (0, _defineProperty2.default)(this, "confirmationMessage", void 0);
    (0, _defineProperty2.default)(this, "copiedFrom", void 0);
    (0, _defineProperty2.default)(this, "description", void 0);
    (0, _defineProperty2.default)(this, "dynamic", void 0);
    (0, _defineProperty2.default)(this, "image", void 0);
    (0, _defineProperty2.default)(this, "meta", void 0);
    (0, _defineProperty2.default)(this, "qrId", void 0);
    (0, _defineProperty2.default)(this, "requiresAsset", void 0);
    (0, _defineProperty2.default)(this, "shortcode", void 0);
    (0, _defineProperty2.default)(this, "steps", void 0);
    (0, _defineProperty2.default)(this, "title", void 0);
    (0, _defineProperty2.default)(this, "uniqueReference", void 0);
    (0, _defineProperty2.default)(this, "url", void 0);
    (0, _defineProperty2.default)(this, "walletStrategy", void 0);
    (0, _defineProperty2.default)(this, "requiresApproval", void 0);
    Object.assign(this, (0, _remeda.clone)(data));
    if ((_this$steps = this.steps) !== null && _this$steps !== void 0 && _this$steps.length) {
      for (let i = 0; i < this.steps.length; i++) {
        this.steps[i].index = i;
        if (!this.steps[i].arguments) {
          // Ensure it's an empty array if no arguments
          this.steps[i].arguments = [];
        }
      }
    }

    // Remove invalid wallet strategy (if it's just an empty object)
    if (data.walletStrategy && !data.walletStrategy.type) {
      this.walletStrategy = null;
    }
  }
  getTitle() {
    if (this.title) {
      return this.title;
    }
    if (this.steps && this.steps.length > 0) {
      let step = this.steps[this.steps.length - 1];
      if ((0, _util.isContractStep)(step)) {
        return step.method;
      }
    }
    return "";
  }
}
exports.Dumbapp = Dumbapp;
//# sourceMappingURL=Dumbapp.js.map